export default __webpack_public_path__ + "static/media/payment.8a38bb61.jpg";